/*
 * File: OrdersFilterTabs.js
 * Project: mp-mobile-app
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: Displays the Mine and All orders tabs on the Orders page
 */
import React from "react";
import { withStyles } from "@material-ui/core/styles";
import { Badge, Tab, Tabs } from "@material-ui/core";
import PropTypes from "prop-types";

const styles = theme => ({
  tabs: {
    background: theme.palette.background.default,
    width: "100%",
    borderBottom: "1px solid" + theme.palette.common.border
  },
  tab: {
    padding: 0,
    color: theme.palette.common.text,
    width: "50%"
  },
  badge: {
    right: theme.spacing(-3)
  }
});

const OrdersTabs = ({
  classes,
  userCount,
  allCount,
  tabValue,
  handleTabChange
}) => {
  const tabLabels = [
    { id: "mine", label: "Mine", count: userCount },
    { id: "all", label: "All", count: allCount }
  ];

  const tabChange = (_, value) => {
    handleTabChange(value);
  };

  // iterates over tabLabels and returns a tab component
  const tabItems = tabLabels.map(item => {
    const id = "order-filters-tab-" + item.id;
    return (
      <Tab
        key={item.id}
        id={id}
        disableRipple
        value={item.id}
        label={
          <Badge
            classes={{ badge: classes.badge }}
            color="secondary"
            badgeContent={item.count}
            max={10000}
          >
            {item.label}
          </Badge>
        }
        className={classes.tab}
      />
    );
  });

  return (
    <Tabs
      value={tabValue}
      variant="fullWidth"
      centered
      textColor="secondary"
      className={classes.tabs}
      onChange={tabChange}
    >
      {tabItems}
    </Tabs>
  );
};

OrdersTabs.propTypes = {
  classes: PropTypes.object.isRequired,
  userCount: PropTypes.number.isRequired,
  allCount: PropTypes.number.isRequired,
  tabValue: PropTypes.string.isRequired,
  handleTabChange: PropTypes.func.isRequired
};
export default withStyles(styles)(OrdersTabs);
